import request from "@/utils/request";

// 查询视频列表
export const  listHumVideo =(query) =>{
    return request({
        url: "/businessservice/humanityVideo/videoList",
        method:"get",
        params: query
    })
}

// 查询视频详情
export const  infoHumVideo =(query) =>{
    return request({
        url: "/businessservice/humanityVideo/videoInfo",
        method:"get",
        params: query
    })
}